<template>
    <loading name="load news detail">
        <div class="container news fix-footer">
            <div class="row mt-3">
                <news-item/>
                <side-panel-news/>
            </div>
        </div>
    </loading>
</template>

<script>
  import SidePanelNews from '../../components/news/SidePanelNews';
  import NewsItem from '../../components/news/NewsItem';
  import { NEWS_TYPES, ROUTER_NAMES } from '../../constants';
  import { mapActions } from 'vuex';

  export default {
    name: 'NewsDetail',
    components: {
      NewsItem,
      SidePanelNews
    },
    methods: {
      ...mapActions(['loadNewsList', 'loadNewsDetail']),
      newsList() {
        return this.loadNewsList({
          type: NEWS_TYPES.LATEST,
          page: 1,
          size: 4
        });
      },
      loadNews(slug) {
        return this.loadNewsDetail({
          slug: slug
        });
      }
    },
    computed: {
      slug() {
        return this.$route.params.slug;
      }
    },
    created() {
      this.$wait.start('load news detail');
      const news = this.loadNews(this.slug);
      const list = this.newsList();
      Promise.all([news, list])
        .then(() => this.$wait.end('load news detail'))
        .catch((e) => {
          const response = e.response ? e.response : {};
          if (response.status == 404) {
            this.$router.push({
              name: ROUTER_NAMES.NOT_FOUND,
              params: {
                0: ROUTER_NAMES.NOT_FOUND
              }
            });
          } else {
            this.$router.push({
              name: ROUTER_NAMES.ERROR
            });
          }
        });
    },
    beforeRouteUpdate(to, from, next) {
      if (to.name === ROUTER_NAMES.NEWS) {
        this.$wait.start('load news detail');
        Promise.all([this.loadNews(to.params.slug), this.newsList()])
          .then(() => this.$wait.end('load news detail'));
      }
      next();
    }
  };
</script>

<style scoped>

</style>
